import { withErrorBoundary, Formatter } from 'shared';
import { SmartButtonLink } from 'ui/smart-buttons';

const Announcement = ({ announcement, base }) => {
  return (
    <div className="Announcement">
      <b>{announcement.title}</b>
      <div className="my-2 body" dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(announcement.text) }} />
      {
        announcement.new_announcement ? (
          <div className="home-chat-link">
            <SmartButtonLink text={announcement.target_name} className="admin-purple inverted primary" to="/home/chat" />
          </div>
        ) : (
          announcement.target_arn && (
            <div className="">
              <SmartButtonLink text={announcement.target_name} className="admin-purple inverted primary" to={`${base}/${announcement.target_path}`} />
            </div>
          )
        )
      }
    </div>
  );
};

const Announcements = ({ announcements, base }) => {
  return (
    <div className="Announcements">
      {
        announcements.map((announcement) => (
          <Announcement announcement={announcement} base={base} key={announcement.id} />
        ))
      }
    </div>
  );
};

export default withErrorBoundary(Announcements);
